import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase/app'; 
import { AuthService } from 'src/app/app-login/auth.service';
import { catchError, map, switchMap, take, tap, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, Resolve, Router } from '@angular/router';

export interface ChatRoom{
    chatName: string,
    chatDescription: string,
    instructorName: string,
    instructorEmail: string,
}

export const users = [
    {
        uid: "asdcajk",
        displayName: 'Jeremy Sistrunk',
        messages: [
            {
                createdAt: new Date(),
                message: "", 
                uid: "asdcajk"

            }
        ]
    }
]
export const chatRoom = [{
    chatName: 'Physicians',
    chatDescription: "Chat with Physicians",
    instructorEmail: 'jeremysistrunk@gmail.com',
    instructorName: 'Jeremy Sistrunk',
    status: 'offline',
    users: {
      "xiiaixii" : {
        "user": {},
        "messages" : []
      }
    }
  }]

@Injectable()

export class ChatService{

    chatRoom = chatRoom
    constructor(
        private afs: AngularFirestore,
        private authSvc: AuthService
    ){}


    saveMessages(instructorUid, uid, text, displayName, currentUid, photoUrl?){

       return photoUrl !== undefined ? Promise.all(
       [ 
            this.afs.collection("Chat-rooms").doc(instructorUid).collection(uid).add({
                createdAt : firebase.firestore.FieldValue.serverTimestamp(),
                photoUrl: photoUrl,
                displayName: displayName,
                content : text,
                uid: currentUid
            }),
            this.saveUserToInstructor(instructorUid, uid, displayName)

        ]
       )  : 
       
       Promise.all(
           [
               this.afs.collection("Chat-rooms").doc(instructorUid).collection(uid).add({
                    createdAt : firebase.firestore.FieldValue.serverTimestamp(),
                    content : text,
                    displayName: displayName,
                    uid: currentUid
                }),
                this.saveUserToInstructor(instructorUid, uid, displayName)
            ]
        )
    }

    getChatroom(){
        return this.chatRoom
    }
    saveUserToInstructor = (instructorUid, uid, displayName) => this.afs.collection("Chat-rooms").doc(instructorUid).set({ users: firebase.firestore.FieldValue.arrayUnion({displayName: displayName, uid: uid})}, {merge:true})

  isInstructor(chatrooms){
    return this.authSvc.returnUser().pipe(
        filter(user => user != null && user.user != null),
        map( user => {
            const idx = chatrooms.find( (chatroom) => chatroom.instructorUid === user.user.uid)
            if( idx !== undefined){
                return {
                    instructorUid: user.user.uid
                }
            }
            else{
                return user
            }
        }),
      catchError( err => of(console.error(err)) ),
      take(1)
    ) 
   }

   getUsers = (uid) => this.afs.collection("Chat-rooms").doc(uid).valueChanges()

   getChatMessages = (instructorUid, uid) => this.afs.collection("Chat-rooms").doc(instructorUid).collection(uid, (query) => query.orderBy('createdAt')).valueChanges()

   isUser(user):user is firebase.User{
        return user.user.uid && user.credential && user.operationType
   }

}

@Injectable()


export class ChatRoomActivationService implements CanActivate{
    constructor(
        private chatSvc: ChatService, 
        private afs: AngularFirestore,
        private router: Router
    ){}
    

    canActivate(){
        const chatroomsCallable = () => this.afs.collection("Chat-rooms").valueChanges()
        
        return chatroomsCallable().pipe(
                switchMap( (chatrooms) => this.chatSvc.isInstructor(chatrooms)    
            ),
            map(data => {
                if( data.instructorUid === undefined )
                {
                    return true
                }
                else{
                    return this.router.parseUrl(`/main/users-dashboard/${data.instructorUid}`)
                }
            }),
            take(1)
        )
    }
}


@Injectable()


export class UserDashboardResolverService implements Resolve<any>{
    constructor(private chatSvc: ChatService){

    }

    resolve(route: ActivatedRouteSnapshot){
        return this.chatSvc.getUsers(route.params.instructorUid).pipe(
            catchError(
                err =>{ 
                    return of(err)}
            ),
            take(1)
        )
    }
}

@Injectable() 

export class UsersChatroomResolverService implements Resolve<any>{
    constructor(
        private chatSvc: ChatService, 
        private authSvc: AuthService,
        private afs: AngularFirestore,

    ){}
    resolve(route: ActivatedRouteSnapshot){
        const uid = route.params.uid
        const instructorUid = route.params.instructorUid
        const chatroomsCallable = () => this.afs.collection("Chat-rooms").doc(instructorUid).collection(uid).valueChanges()
        .pipe(take(1))
        return chatroomsCallable()
    }
}

@Injectable()

export class ChatRoomsResolverService{
    constructor(
        private afs: AngularFirestore, private authSvc: AuthService
    ){}

    resolve(){
        const chatroomsCallable = () => this.afs.collection("Chat-rooms").valueChanges()
        return chatroomsCallable()
        .pipe(
            map((data : any[]) => data.filter( doc => doc.publish === true)),
            take(1))
    }
}

@Injectable()


export class UsersChatRoomActivationService implements CanActivate{
    constructor(
        private chatSvc: ChatService, 
        private afs: AngularFirestore,
        private router: Router
    ){}
    

    canActivate(){
        const chatroomsCallable = () => this.afs.collection("Chat-rooms").valueChanges()
        
        return chatroomsCallable().pipe(
                switchMap( (chatrooms) => this.chatSvc.isInstructor(this.chatSvc.chatRoom)),
                map( data => data ? 
                this.router.parseUrl(`/main/users-dashboard/${data.user.uid}`) : 
                true
            ),
            take(1)
        )
    }
}

